import superMeta from '../_AR_CAT/metaArCatNode.mjs'

export default {
    ...superMeta,
    mapProp: 'map',
    name: '业务数据源',
    type: 'AO_DS',
}
